import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { UnifiedMstMetrics } from "../api/scans";

function formatPercent(value: number | null | undefined) {
  if (value === null || value === undefined) return "—";
  return `${Math.round(value * 100)}%`;
}

// en=true — английские подписи (production-кабинет physician);
// по умолчанию русские (исследовательский кабинет doctor/admin)
export default function MstMetricsTable({
  metrics,
  nTrials,
  en = false,
}: {
  metrics: UnifiedMstMetrics;
  nTrials: number | null;
  en?: boolean;
}) {
  if (!metrics) return null;
  const L = en
    ? {
        oldAcc: "Accuracy on old (old → old)",
        lureSim: "Lures recognized (lure → similar)",
        lureFa: "False alarms (lure → old)",
        newCr: "New correctly rejected (new → new)",
        rtOld: "Avg response time (old)",
        rtLure: "Avg response time (lure)",
        rtNew: "Avg response time (new)",
        timeouts: "Timeouts",
        trials: "Trials (total / encoding / recognition)",
        duration: "Duration",
        sec: "s",
        ms: "ms",
      }
    : {
        oldAcc: "Точность на старых (old → old)",
        lureSim: "Похожие распознаны (lure → similar)",
        lureFa: "Ложные тревоги (lure → old)",
        newCr: "Новые отклонены (new → new)",
        rtOld: "Среднее время ответа (old)",
        rtLure: "Среднее время ответа (lure)",
        rtNew: "Среднее время ответа (new)",
        timeouts: "Таймауты",
        trials: "Трейлы (всего / кодирование / узнавание)",
        duration: "Длительность",
        sec: "с",
        ms: "мс",
      };
  const ms = (v: number | null | undefined) =>
    v === null || v === undefined ? "—" : `${Math.round(v)} ${L.ms}`;
  const rows: { label: string; value: string }[] = [
    { label: "LDI (Lure Discrimination Index)", value: metrics.ldi.toFixed(2) },
    { label: "Recognition Index", value: metrics.recognition_index.toFixed(2) },
    { label: L.oldAcc, value: formatPercent(metrics.old_accuracy) },
    { label: L.lureSim, value: formatPercent(metrics.lure_similar_rate) },
    { label: L.lureFa, value: formatPercent(metrics.lure_false_alarm_rate) },
    { label: L.newCr, value: formatPercent(metrics.new_correct_reject_rate) },
    { label: L.rtOld, value: ms(metrics.avg_rt_old_ms) },
    { label: L.rtLure, value: ms(metrics.avg_rt_lure_ms) },
    { label: L.rtNew, value: ms(metrics.avg_rt_new_ms) },
    { label: L.timeouts, value: `${metrics.timeout_count}` },
    {
      label: L.trials,
      value: `${nTrials ?? metrics.total_trials} / ${metrics.encode_trials} / ${metrics.test_trials}`,
    },
    {
      label: L.duration,
      value: metrics.duration_sec != null ? `${Math.round(metrics.duration_sec)} ${L.sec}` : "—",
    },
  ];

  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.label}>
              <TableCell sx={{ color: "text.secondary" }}>{row.label}</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>
                {row.value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
